const _ = require('underscore');
class AssetFilter {
  constructor() {
    this.filters = [];
  }

  getFilters() {
    return this.filters;
  }

  clearFilters() {
    return (this.filters = []);
  }

  filterAssets($el, method, value) {
    const filterData = [{ attribute: method, value }];
    if ($el.hasClass('filtered')) {
      return this.removeFilter(filterData);
    } else {
      return this.addFilter(filterData);
    }
  }

  //-- Private

  addFilter(filters) {
    return (() => {
      const result = [];
      for (var filterData of filters) {
        if (!this.filters[filterData.attribute]) {
          this.filters[filterData.attribute] = [];
        }
        if (!_.contains(this.filters[filterData.attribute], filterData.value)) {
          if ($.isArray(filterData.value)) {
            result.push(
              $.merge(this.filters[filterData.attribute], filterData.value),
            );
          } else {
            result.push(
              this.filters[filterData.attribute].push(filterData.value),
            );
          }
        } else {
          result.push(undefined);
        }
      }
      return result;
    })();
  }

  removeFilter(filters) {
    return (() => {
      const result = [];
      for (var filterData of filters) {
        if (this.filters[filterData.attribute]) {
          result.push(
            (this.filters[filterData.attribute] = _.reject(
              this.filters[filterData.attribute],
              function (val) {
                if ($.isArray(filterData.value)) {
                  return $.inArray(val, filterData.value) > -1;
                } else {
                  return val === filterData.value;
                }
              },
            )),
          );
        } else {
          result.push(undefined);
        }
      }
      return result;
    })();
  }
}

//-----------  Export  -----------#
module.exports = AssetFilter;
